import * as React from 'react';
import { Button, FormControl, FormGroup, ControlLabel, Alert, Panel, ButtonToolbar, Glyphicon } from 'react-bootstrap';
import { MessageType, TicketVisibility } from '@nkr/enums/index';
import { IContactListResponse } from '@nkr/store/index';
import JoditEditor from '@nkr/components/editor';
import config from '../jodit-editor-config';
import { ITicket, IUser, ISelectItem, ITicketCannedResponse } from '@nkr/models/index';
import AsyncCreatableSelect from 'react-select/async-creatable';
import Select, { InputActionMeta, OptionsType } from 'react-select';
import { DropdownIndicator } from '../dropdown-indicator';
import MyUploader from '../file-upload';
import { ITicketMessageFile } from '@nkr/models/ticketing/ticket-message-file';
import { helpers } from './helpers';
import { debounce } from 'lodash';

const editorConfig = { ...config, height: '250px' };

interface IProps {
    show: boolean,
    ticket: ITicket,
    user: IUser,
    messageType: MessageType,
    initialSubject: string,
    attachment: ITicketMessageFile,
    cannedResponse: ITicketCannedResponse,
    onGetContacts: (search: string) => Promise<IContactListResponse>,
    onShowCannedResponses: () => void,
    onSave: (from: string, to: ISelectItem, cc: ISelectItem[], bcc: ISelectItem[], subject: string, message: string, visibility: TicketVisibility, files: File[]) => void,
    onCancel: () => void
}

interface IValidation {
    subject: boolean,
    message: boolean
}

interface IState {
    fromList: ISelectItem[],
    from: ISelectItem,
    to: ISelectItem,
    includeCc: boolean,
    showCcOptions: boolean,
    cc: ISelectItem[],
    includeBcc: boolean,
    showBccOptions: boolean,
    bcc: ISelectItem[],
    subject: string,
    message: string,
    initialFiles: File[],
    files: File[],
    visibility: TicketVisibility,
    validation: IValidation
}

class Reply extends React.Component<IProps, IState> {
    readonly state: IState = {
        fromList: helpers.getFromList(this.props.user.firstName, this.props.user.lastName, this.props.user.username, this.props.user.email),
        from: helpers.getFromList(this.props.user.firstName, this.props.user.lastName, this.props.user.username, this.props.user.email)[0],
        to: helpers.getContact(this.props.ticket),
        includeCc: false,
        showCcOptions: false,
        cc: [],
        includeBcc: false,
        showBccOptions: false,
        bcc: [],
        subject: this.props.initialSubject,
        //message: '<br/><br/><div style='border-left: 1px dotted silver; padding-left: 5px;'>' + this.props.ticket.messages.filter(x => x.type != MessageType.Note).map((x, i) => '<div style='margin-left:' + ((i + 1) * 20) + 'px'>' + x.message + '</div>').join('\r\n') + '</div>',
        message: '',
        initialFiles: this.props.attachment != null ? [new File(['foo', 'bar'], 'foobar.txt')] : [],
        files: [],
        visibility: TicketVisibility.Nkr,
        validation: {
            subject: true,
            message: true
        }
    }

    componentWillReceiveProps = (nextProps: IProps) => {
        if (nextProps.cannedResponse != null) {
            this.setState({
                message: nextProps.cannedResponse.message
            });
        }
    }

    componentDidMount = () => {

    }

    handleFromChange = (from: ISelectItem) => {
        this.setState({
            from
        });
    }

    handleCcInputChange = (value: string, action: InputActionMeta) => {
        this.setState({
            showCcOptions: value.length >= 3
        });
    }

    handleIncludeCc = () => {
        this.setState({
            includeCc: true
        });
    }

    handleBccInputChange = (value: string, action: InputActionMeta) => {
        this.setState({
            showBccOptions: value.length >= 3
        });
    }

    handleIncludeBcc = () => {
        this.setState({
            includeBcc: true
        });
    }

    handleCcChange = (list: ISelectItem[]) => {
        let newList: ISelectItem[] = list.map(x => {
            if (x.email == undefined) {
                return { value: x.value, label: x.label, email: x.value };
            } else {
                return x;
            }
        });

        this.setState({
            cc: newList
        });
    }

    handleBccChange = (list: ISelectItem[]) => {
        let newList: ISelectItem[] = list.map(x => {
            if (x.email == undefined) {
                return { value: x.value, label: x.label, email: x.value };
            } else {
                return x;
            }
        });

        this.setState({
            bcc: newList
        });
    }

    handleSubjectChange = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        this.setState({
            subject: e.currentTarget.value
        });
    }

    handleMessageChange = (message: string) => {
        this.setState({
            message
        });
    }

    handleFilesChanged = (file: File, status: string) => {
        let files = [...this.state.files];

        if (status == 'done') {
            files.push(file);
        }

        if (status == 'removed') {
            files = files.filter(x => x.name != file.name);
        }

        this.setState({
            files
        });
    }

    handleVisibilityChange = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        this.setState({
            visibility: parseInt(e.currentTarget.value)
        });
    }

    handleSave = () => {
        let { from, to, cc, bcc, subject, message, visibility, files } = this.state;

        let messageValid = message != '';
        let subjectValid = subject != '';
        let validation: IValidation = { message: messageValid, subject: subjectValid };

        this.setState({
            validation
        }, () => {
            if (validation.message && validation.subject)
                this.props.onSave(from.email, to, cc, bcc, subject, message, visibility, files);
        });
    }

    handleCancel = () => {
        this.props.onCancel();
    }

    loadContactOptions = debounce((search: string, callback: ((options: OptionsType<any>) => void)) => {
        if (search.length >= 3) {
            this.props.onGetContacts(search)
                .then(response => {
                    if (response.data.success) {
                        let results = response.data.results.map(x => { return { value: x.id, label: `${x.firstName + ' ' + x.lastName} (${x.email})`, email: x.email }; });
                        callback(results);
                    }
                })
                .catch((error) => {
                    callback(error);
                });
        } else {
            callback([]);
        }
    }, 500)

    render = () => {
        let editor = document.getElementsByClassName('jodit_wysiwyg');
        //editor.focus();

        return (
            <>
                <Panel>
                    <Panel.Heading style={{ backgroundColor: '#f5f7f9', borderBottom: '0 none' }}>
                        <FormGroup style={{ display: 'flex', alignItems: 'center', marginBottom: 0, width: '100%' }}>
                            <div style={{ marginRight: 5 }}>From:</div>
                            <Select
                                isSearchable={false}
                                styles={{
                                    container: defaultStyles => ({
                                        ...defaultStyles,
                                        width: '100%',
                                        height: 34,
                                        minHeight: 34
                                    }),
                                    control: defaultStyles => ({
                                        ...defaultStyles,
                                        height: 34,
                                        minHeight: 34
                                    }),
                                    indicatorSeparator: defaultStyles => ({ ...defaultStyles }),
                                    dropdownIndicator: defaultStyles => ({
                                        ...defaultStyles,
                                        color: 'black'
                                    })
                                }}
                                components={{ DropdownIndicator }}
                                options={this.state.fromList}
                                value={this.state.from}
                                onChange={this.handleFromChange}
                            />
                        </FormGroup>
                    </Panel.Heading>
                    <Panel.Heading style={{ backgroundColor: '#f5f7f9', borderBottom: '0 none' }}>
                        <FormGroup style={{ display: 'flex', alignItems: 'center', marginBottom: this.state.includeCc || this.state.includeBcc ? 5 : 0 }}>
                            <div style={{ marginRight: 5 }}>To:</div>
                            <FormControl
                                disabled
                                value={this.state.to.label}
                            />
                            <div style={{ display: 'flex', marginLeft: 5 }}>
                                <Button bsStyle='link' bsSize='xs' onClick={this.handleIncludeCc}>Cc</Button>
                                <Button bsStyle='link' bsSize='xs' onClick={this.handleIncludeBcc}>Bcc</Button>
                            </div>
                        </FormGroup>

                        {this.state.includeCc && (
                            <FormGroup style={{ display: 'flex', alignItems: 'center', marginBottom: this.state.includeBcc ? 5 : 0 }}>
                                <div style={{ marginRight: 5 }}>Cc:</div>
                                <div style={{ width: '100%' }}>
                                    <AsyncCreatableSelect
                                        value={this.state.cc}
                                        isMulti={true}
                                        loadOptions={this.state.showCcOptions ? this.loadContactOptions : null}
                                        components={{ DropdownIndicator }}
                                        styles={{
                                            indicatorSeparator: defaultStyles => ({ ...defaultStyles }),
                                            dropdownIndicator: defaultStyles => ({
                                                ...defaultStyles,
                                                color: 'black'
                                            }),
                                            menu: defaultStyles => ({
                                                ...defaultStyles,
                                                zIndex: 999999
                                            }),
                                            menuList: defaultStyles => ({
                                                ...defaultStyles,
                                                zIndex: 999999
                                            })
                                        }}
                                        onInputChange={this.handleCcInputChange}
                                        onChange={this.handleCcChange}
                                    />
                                </div>
                            </FormGroup>
                        )}

                        {this.state.includeBcc && (
                            <FormGroup style={{ display: 'flex', alignItems: 'center', marginBottom: 0 }}>
                                <div style={{ marginRight: 5 }}>Bcc</div>
                                <div style={{ width: '100%' }}>
                                    <AsyncCreatableSelect
                                        value={this.state.bcc}
                                        isMulti={true}
                                        loadOptions={this.state.showBccOptions ? this.loadContactOptions : null}
                                        components={{ DropdownIndicator }}
                                        styles={{
                                            indicatorSeparator: defaultStyles => ({ ...defaultStyles }),
                                            dropdownIndicator: defaultStyles => ({
                                                ...defaultStyles,
                                                color: 'black'
                                            }),
                                            menu: defaultStyles => ({
                                                ...defaultStyles,
                                                zIndex: 99999
                                            }),
                                            menuList: defaultStyles => ({
                                                ...defaultStyles
                                            })
                                        }}
                                        onInputChange={this.handleBccInputChange}
                                        onChange={this.handleBccChange}
                                    />
                                </div>
                            </FormGroup>
                        )}
                    </Panel.Heading>
                    <Panel.Body>
                        {(!this.state.validation.subject || !this.state.validation.subject) && (
                            <Alert bsStyle='danger'>
                                Please fix the items highlighted in <strong>red</strong> below...
                            </Alert>
                        )}

                        <FormGroup validationState={this.state.validation.subject ? null : 'error'}>
                            <ControlLabel>Subject</ControlLabel>
                            <FormControl
                                value={this.state.subject}
                                onChange={this.handleSubjectChange}
                            />

                            {!this.state.validation.subject && (
                                <span className='help-block'>Please enter the subject of the message...</span>
                            )}
                        </FormGroup>

                        <FormGroup validationState={this.state.validation.message ? null : 'error'}>
                            <ControlLabel>Message</ControlLabel>
                            <JoditEditor
                                value={this.state.message}
                                config={editorConfig}
                                setFocus={true}
                                onChange={this.handleMessageChange}
                                onBlur={() => null}
                            />

                            {!this.state.validation.message && (
                                <span className='help-block'>Please enter the contents of the message...</span>
                            )}

                            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 5 }}>
                                <div>
                                    <Button bsSize='xs' title='Canned Responses' onClick={this.props.onShowCannedResponses}><Glyphicon glyph='comment' /></Button>
                                </div>
                                <div>
                                    <MyUploader initialFiles={this.state.initialFiles} filesChanged={this.handleFilesChanged} />
                                </div>
                            </div>
                        </FormGroup>

                        <ButtonToolbar style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <Button bsStyle='primary' onClick={this.handleSave}>{this.props.messageType == MessageType.Note ? 'Save' : 'Send Reply'}</Button>
                            <Button onClick={this.handleCancel}>Cancel</Button>
                        </ButtonToolbar>
                    </Panel.Body>
                </Panel>
            </>
        );
    }
}

export default Reply;